<template>
  <div class="customize-page">
    <!-- START : Customize Item Header -->
    <WCMobileSubpageHeader :title="heading" />
    <!-- END : Customize Your Item Header -->

    <!-- START : Customize Your Item Content -->
    <WCSpinner v-if="!loadFailedError && loading" position="center" size="xl" />
    <div v-if="loadFailedError">{{ loadFailedError }}</div>
    <div v-if="!loadFailedError && !loading && item">
      <WCItemModifierRootMobile
        :item="item"
        :lineItem="lineItem"
        :editingItem="editingItem"
        :variation="variation"
        :cartInstructions="cartInstructions"
        :hasAddToList="hasAddToList"
        :isFavoriteMTOItem="favoriteMTOItem"
        @goBack="goBack"
      />
    </div>
    <!-- END : Customize Your Item Content -->
  </div>
</template>
<script>
import axios from 'axios';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCMobileSubpageHeader from '@/components/WCMobileSubpageHeader/WCMobileSubpageHeader.vue';
import WCItemModifierRootMobile from '@/modules/itemModifiers/components/WCItemModifierRoot/WCItemModifierRootMobile.vue';
import { capitalizeFirstLetter } from '@/utils/formatters';
import CartControls from '@/modules/cart/mixins/CartControls/CartControls';
import { mapGetters } from 'vuex';

export default {
  name: 'CustomizeYourItems',
  data() {
    return {
      loading: false,
      loadFailedError: null,
      item: null,
      editingItem: false,
      lineItem: null,
      variation: null,
      cartInstructions: null,
      hasAddToList: false,
      favoriteMTOItem: false,
    };
  },
  components: {
    WCSpinner,
    WCItemModifierRootMobile,
    WCMobileSubpageHeader,
  },
  mixins: [CartControls],
  async created() {
    await this.getProductDetails();
    this.hasAddToList = !this.isGuest && [true, 'true'].includes(this.$route.query.hasAddToList);
    this.favoriteMTOItem =
      !this.isGuest && [true, 'true'].includes(this.$route.query.favoriteMTOItem);
  },
  methods: {
    /**
     * Method to get product details based on the Edit item or new product item
     */
    async getProductDetails() {
      try {
        this.editingItem = Boolean(
          [true, 'true'].includes(this.$route.query.editingItem) || this.editingItem,
        );
        this.variation = this.$route.query.variation || this.variation;
        if (this.variation) {
          // To get line item from cart
          this.lineItem = this.getItemLineItem({ id: this.$route.params.id }, this.variation);
          this.item = this.lineItem.item;
          this.cartInstructions = this.lineItem.instructions;
        } else {
          await this.fetchProductDetails();
        }
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Method to get product details
     */
    async fetchProductDetails() {
      this.loading = true;
      this.loadFailedError = null;
      try {
        const response = await axios.get(`/api/i/${this.$route.params.id}`);
        this.item = response.data;
      } catch (error) {
        this.loading = false;
        this.loadFailedError = error;
        console.error(error);
      }
      this.loading = false;
    },

    /**
     * Method to route one step back
     */
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters({
      isGuest: 'user/isGuest',
    }),
    /**
     * Method to get page title
     */
    heading() {
      const itemName = this.$route.params.name || (this.item && this.item.name);
      const capitalizedItemName = itemName
        .split(' ')
        .map(value => capitalizeFirstLetter(value))
        .join(' ');
      return `${this.$t('customizeYourItem', { itemName: capitalizedItemName })}`;
    },
  },
};
</script>
